import script from "./OTPComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OTPComponent.vue?vue&type=script&setup=true&lang=js"

import "./OTPComponent.vue?vue&type=style&index=0&id=267ce559&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267ce559"]])

export default __exports__